/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import React from 'react';
import SuccessSvg from 'images/v5/icons/face-content.svg';
import ErrorSvg from 'images/v5/icons/face-sad.svg';
import styles from './ComponentBadge.module.scss';
function ComponentBadge({ name = '-', category = '-', missingData = false, onClick, }) {
    return (React.createElement("div", { className: classNames(styles.wrap, { [styles.clickable]: onClick }), onClick: onClick },
        React.createElement("div", { className: classNames(styles.icon, { [styles.error]: missingData }) }, missingData ? React.createElement(ErrorSvg, null) : React.createElement(SuccessSvg, null)),
        React.createElement("div", { className: styles.text },
            React.createElement("p", { title: name }, name),
            React.createElement("span", null, category))));
}
export default ComponentBadge;
